import React from 'react';

interface PartialFeaturesProps {
  block: {
    _template: string;
    list_columns?: string;
    items?: {
      title: string;
      subtitle: string;
      icon: string;
      icon_position: string;
    }[];
  };
}

const PartialFeatures = ({ block }: PartialFeaturesProps) => {
  return (
    <section className={`partial ${block._template}`}>
      {block?.items?.map((item, index) => {
        let icon_position_class = 'icon-left';
        if (item.icon_position === 'Right') {
          icon_position_class = 'icon-right';
        }

        return (
          <div
            key={index}
            className={`item ${icon_position_class}`}
          >
            <div className='title-wr'>
              {item.icon && (
                <div className='icon'>
                  <img
                    src={item.icon}
                    alt={item.title}
                    title={item.title}
                  />
                </div>
              )}
              {item.title && (
                <div
                  className='title'
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></div>
              )}
            </div>

            {item.subtitle && (
              <div
                className='subtitle'
                dangerouslySetInnerHTML={{ __html: item.subtitle }}
              ></div>
            )}
          </div>
        );
      })}
    </section>
  );
};

export default PartialFeatures;
